<script>
import Accordion from '@/components/Accordion/Main';
import AccordionItem from '@/components/Accordion/Item';

export default {
  props: {},
  components: {
    Accordion,
    AccordionItem,
  },
};
document.querySelector('#app').classList.add('overflow-hidden');
</script>

<template>
  <div class="section section_gray section_indents">
    <div class="container">
      <div class="flex flex-col lg:flex-row">
        <div class="w-full lg:w-2/3 xl:w-3/4 mr-5">
          <h2 class="title-h2 mb-6">Ответы на популярные вопросы</h2>
          <accordion>
            <accordion-item>
              <template #accordion-trigger>
                <p>Можно&nbsp;ли купить Volkswagen Multivan в&nbsp;кредит?</p>
              </template>

              <template #accordion-content>
                <p>
                  Да, у&nbsp;нас есть кредитные программы с&nbsp;низкими
                  процентными ставками.
                </p>
              </template>
            </accordion-item>

            <accordion-item>
              <template #accordion-trigger>
                <p>
                  Как проверить техническое состояние подержанного автомобиля?
                </p>
              </template>

              <template #accordion-content>
                <p>
                  В&nbsp;&laquo;Прагматике&raquo; все автомобили проходят
                  комплексную диагностику перед продажей.
                </p>
              </template>
            </accordion-item>

            <accordion-item>
              <template #accordion-trigger>
                <p>Как работает программа Trade-In?</p>
              </template>

              <template #accordion-content>
                <p>
                  Вы&nbsp;можете обменять свой старый автомобиль
                  на&nbsp;Volkswagen Multivan с&nbsp;пробегом. Мы&nbsp;оценим
                  ваш авто и&nbsp;зачтем его стоимость в&nbsp;счет покупки.
                </p>
              </template>
            </accordion-item>
            <accordion-item>
              <template #accordion-trigger>
                <p>
                  Какие дополнительные услуги доступны при покупке Volkswagen
                  Multivan?
                </p>
              </template>

              <template #accordion-content>
                <p>
                  Мы&nbsp;предоставляем полный комплекс услуг, включая выгодное
                  кредитование, страхование, гарантийное обслуживание, помощь
                  в&nbsp;регистрации автомобиля и&nbsp;организацию тест-драйвов.
                  Наши специалисты помогут оформить сделку максимально быстро
                  и&nbsp;комфортно.
                </p>
              </template>
            </accordion-item>
          </accordion>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
p {
  color: #81869a;
}
</style>
